import { useState, useEffect } from 'react';
import { postAPI } from "../../app/api";
import { store } from '../../app/store';

// Check if user is admin
export const isAdmin = () => {
    try {
        const store_data = JSON.parse(store());
        return store_data?.role === 'ADMIN' || store_data?.user_type === 'ADMIN';
    } catch (error) {
        console.error('Admin check error:', error);
        return false;
    }
};

// Hook to check permissions (returns synchronous value after loading)
export const usePermission = (module, page, action) => {
    const [hasAccess, setHasAccess] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkPermission = async () => {
            // Admin has all permissions
            if (isAdmin()) {
                setHasAccess(true);
                setLoading(false);
                return;
            }

            try {
                const store_data = JSON.parse(store());
                const user_id = store_data?.user_id || store_data?.id;
                
                const response = await postAPI("/users/check-permission", { 
                    user_id, 
                    module, 
                    page, 
                    action 
                });
                
                setHasAccess(response?.status === 1 && response?.hasPermission === true);
            } catch (error) {
                console.error('Permission check error:', error);
                setHasAccess(false);
            } finally {
                setLoading(false);
            }
        };

        checkPermission();
    }, [module, page, action]);

    return { hasAccess, loading };
};

// Async function to check permission (for one-time checks)
export const hasPermission = async (module, page, action) => {
    // Admin has all permissions
    if (isAdmin()) {
        return true;
    }

    try {
        const store_data = JSON.parse(store());
        const user_id = store_data?.user_id || store_data?.id;
        
        const response = await postAPI("/users/check-permission", { 
            user_id, 
            module, 
            page, 
            action 
        });
        console.log("Permission Response:", response?.status === 1 && response?.hasPermission === true, { 
            user_id, 
            module, 
            page, 
            action 
        });
        return response?.status === 1 && response?.hasPermission === true;
    } catch (error) {
        console.error('Permission check error:', error);
        return false;
    }
};

// Get all user permissions (future use)
export const getUserPermissions = () => {
    try {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        return userData.permissions || [];
    } catch (error) {
        console.error('Get permissions error:', error);
        return [];
    }
};
